/**
 * Meeting table column configuration - responsive design
 */

import { ColumnConfig } from '../hooks/useTablePreferences';

export const meetingColumns: ColumnConfig[] = [
  {
    key: 'date',
    label: 'Date',
    defaultWidth: 150,
    minWidth: 130,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'type',
    label: 'Type',
    defaultWidth: 120,
    minWidth: 100,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'therapist',
    label: 'Therapist',
    defaultWidth: 150,
    minWidth: 130,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'status',
    label: 'Status',
    defaultWidth: 100,
    minWidth: 90,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'duration',
    label: 'Duration',
    defaultWidth: 90,
    minWidth: 80,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  // Hidden by default - available via Manage Columns
  {
    key: 'title',
    label: 'Title',
    defaultWidth: 200,
    minWidth: 150,
    visible: false,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'notes',
    label: 'Notes',
    defaultWidth: 200,
    minWidth: 150,
    visible: false,
    sortable: false,
    resizable: true,
    draggable: true,
  },
  {
    key: 'created_at',
    label: 'Created At',
    defaultWidth: 150,
    minWidth: 130,
    visible: false,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'updated_at',
    label: 'Updated At',
    defaultWidth: 150,
    minWidth: 130,
    visible: false,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'source',
    label: 'Source',
    defaultWidth: 100,
    minWidth: 80,
    visible: false,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'reason_of_cancelation',
    label: 'Reason of Cancellation',
    defaultWidth: 180,
    minWidth: 140,
    visible: false,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'cancellation_note',
    label: 'Cancellation Note',
    defaultWidth: 180,
    minWidth: 140,
    visible: false,
    sortable: false,
    resizable: true,
    draggable: true,
  },
  {
    key: 'cancelation_time',
    label: 'Cancellation Time',
    defaultWidth: 150,
    minWidth: 130,
    visible: false,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'summary_saved',
    label: 'Summary Saved',
    defaultWidth: 120,
    minWidth: 100,
    visible: false,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'summary_ready',
    label: 'Summary Ready',
    defaultWidth: 120,
    minWidth: 100,
    visible: false,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'summary_approved',
    label: 'Summary Approved',
    defaultWidth: 130,
    minWidth: 110,
    visible: false,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'summary_sent',
    label: 'Summary Sent',
    defaultWidth: 110,
    minWidth: 90,
    visible: false,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'has_transcript',
    label: 'Transcript',
    defaultWidth: 90,
    minWidth: 80,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'has_rt_transcript',
    label: 'RT Transcript',
    defaultWidth: 110,
    minWidth: 90,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
];
